export default {"src":"/_next/static/media/upload_drop.544320e8.svg","height":54,"width":54};